//import palette from '../palette';
export default {
  root: {
    backgroundColor: '#dee0e2',
    borderRadius: '5px'
  },
  container: {
    display: 'flex',
    //flexDirection: 'column-reverse',
    flexDirection: 'column-reverse',
  },
  editor: {
    backgroundColor: '#dee0e2',
    padding: '20px',
    height: '150px',
    maxHeight: '150px',
    overflow: 'auto',
    borderRadius: '5px'
  },
  toolbar: {
    borderTop: '1px solid gray',
    backgroundColor: '#ebebeb'
  },
  placeHolder: {
    backgroundColor: '#dee0e2',
    //marginTop: 55,
    paddingLeft: 20,
    width: 'inherit',
    position: 'absolute',
    top: '20px'
  }
};
